import React from "react"
import Grid from '@material-ui/core/Grid';

/* importing custom modules */
import StaticExpander from '../components/Material-UI-Components/StaticExpander.js';
import OffersTable from '../components/Material-UI-Components/Offers-Table.js';
import Layout from '../components/layout'
import ContactForm from '../components/Custom Modules/ContactForm';
import SEO from "../components/seo"

/* importing json files */
import CareerCounselling from '../components/Page-Data/CareerCounselling.json';
import VisionOffer from "../components/Page-Data/VisionOffer.json";

/* importing images */
import Logo from '../images/CareerCounsselling/logo.png';

export default function CareerCounseling(){
  return(
  <Layout>
    <SEO 
      title="Best Career Counselling and Counsellers in Jaipur India at Pratiiti.com" 
      description="Career Counselling-Pratiiti.com provide you qualified counsellors for career counselling at affordable rates."
      canonical={"https://www.pratiiti.in/career-counselling"}
    />
    <div className="careerCounselling">
    <Grid xs={12} md={6} sm={3}>
      <div className="logo">
        <img src={Logo} alt="why counselling logo"/>
      </div>
    </Grid>
    <div>
      
        <StaticExpander data = {CareerCounselling} />
        <OffersTable data = {VisionOffer}/>
	  </div>
    <ContactForm/>
    </div>
  </Layout>
)
}